module.exports = __webpack_public_path__ + "static/media/radio-checked.8ef5b18d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/radio-checked.svg
// module id = 695
// module chunks = 0